<template>

    <div class="progress-monitor-step-4">

        <b-form-group>
            <label>
                What is the average (current performance) for this student, prior to the start of the intervention?
            </label>
            <b-input-group :append="docData.formatTitle">
                <b-form-input type="number"
                              v-model="docData.averageRating"/>
            </b-input-group>
        </b-form-group>

        <b-form-group>
            <label>
                How many data points were used to calculate this baseline?
            </label>
            <b-form-input type="number"
                          v-model="docData.dataPoints"/>
        </b-form-group>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ProgressMonitorStep4",
        mixins: [ToolMixin],
    })

</script>


